import React from 'react';
import './rangSlider.css';

import Label from '../../Label';

export default function RangeSlider(props) {
  const {label, min = -100, max = 100, value, inputId, containerStyle, sliderStyle, onChange} = props;
  return (
    <div className="input-range-slider-container" style={containerStyle}>
      <Label>{label}</Label>
      <input
        type="range"
        id={inputId}
        min={min}
        max={max}
        value={value}
        style={sliderStyle}
        className="input-range-slider"
        onChange={onChange}
      />
    </div>
  );
}